// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // Sidebar / titles
  'Khareef Photos': 'خريف ظفار بعدستكم',
  'Khareef Dhofar through your lens': 'خريف ظفار بعدستكم',
  'Something else': 'شي ثاني',
  'Share your photo from Khareef Dhofar with us': 'شاركنا صورتك في خريف ظفار',
  'Share your photo from Khareef Dhofar with us through our website':
    'شاركنا صورتك في خريف ظفار من خلال موقعنا الالكتروني',

  // Public page
  'Shared Photos': 'الصور المشاركة',
  'Share now': 'شارك الآن',
  'Public Page': 'الصفحة العامة',
  'Preview': 'معاينة',
  'No photos have been shared yet': 'لم تتم مشاركة أي صور بعد',

  // Management / moderation
  'Manage Submissions': 'إدارة المشاركات',
  'Submissions': 'المشاركات',
  'Submissions List': 'قائمة المشاركات',
  'Participant': 'المشارك',
  'Photo title': 'عنوان الصورة',
  'Mobile Number': 'رقم الهاتف',
  'Instagram': 'إنستقرام',
  'Reference Number': 'الرقم المرجعي',
  'Open Instagram profile': 'فتح حساب إنستقرام',
  'Description': 'الوصف',
  'Location': 'الموقع',
  'Submitted at': 'تاريخ الإرسال',
  'Status': 'الحالة',
  'Actions': 'الإجراءات',
  'All': 'الكل',
  'Pending': 'قيد المراجعة',
  'Pending Review': 'قيد المراجعة',
  'Approved': 'معتمدة',
  'Published': 'منشورة',
  'Rejected': 'مرفوضة',
  'Review': 'مراجعة',
  'Approve': 'اعتماد',
  'Publish': 'نشر',
  'Reject': 'رفض',
  'View': 'عرض',
  'View Details': 'عرض التفاصيل',
  'Photo Details': 'تفاصيل الصورة',
  'Delete': 'حذف',

  // Search / sort / pagination
  'Search by participant, title or location': 'ابحث بالمشارك أو العنوان أو الموقع',
  'Sort by': 'ترتيب حسب',
  'Newest first': 'الأحدث أولاً',
  'Oldest first': 'الأقدم أولاً',
  'Participant (A–Z)': 'المشارك (أ - ي)',
  'Participant (Z–A)': 'المشارك (ي - أ)',
  'No submissions found': 'لا توجد مشاركات',
  'No submissions match your search': 'لا توجد مشاركات مطابقة لبحثك',
  'Pagination': 'ترقيم الصفحات',

  // Dialogs
  'Reject Photo': 'رفض الصورة',
  'Rejection Reason': 'سبب الرفض',
  'Enter the reason for rejecting this photo': 'أدخل سبب رفض هذه الصورة',
  'Please enter a reason for rejection': 'يرجى إدخال سبب الرفض',
  'You are rejecting the submission by': 'أنت بصدد رفض مشاركة',
  'Delete Photo': 'حذف الصورة',
  'Are you sure you want to delete this photo? This action cannot be undone.':
    'هل أنت متأكد أنك تريد حذف هذه الصورة؟ لا يمكن التراجع عن هذا الإجراء.',
  'Image Preview': 'معاينة الصورة',
  'Close': 'إغلاق',

  // Feedback
  'Photo deleted': 'تم حذف الصورة',
  'Something went wrong': 'حدث خطأ ما',
  'You are not authorized to manage Khareef photos': 'ليس لديك صلاحية لإدارة صور الخريف',

  // Participation guide steps
  'Participation Guide': 'دليل المشاركة في الموقع الالكتروني',
  'Enter participation page': 'دخول صفحة المشاركة',
  'Fill the participation form': 'تعبئة نموذج المشاركة',
  'Send participation': 'إرسال المشاركة',
  'Review participation': 'مراجعة المشاركة',
  'Approve participation': 'اعتماد المشاركة',
  'Publish photo': 'نشر الصورة',
};
